import { render, staticRenderFns } from "./nice-switch.vue?vue&type=template&id=1c486e58&scoped=true"
import script from "./nice-switch.vue?vue&type=script&lang=js"
export * from "./nice-switch.vue?vue&type=script&lang=js"
import style0 from "./nice-switch.vue?vue&type=style&index=0&id=1c486e58&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c486e58",
  null
  
)

export default component.exports